<script lang="ts">
  import { M2 } from '../modules';
  import { trapFocus } from '../actions/trapFocus';
  import type { Station } from '../types';

  export let open: boolean = false;
  export let station: Station | null = null;
  export let onClose: () => void = () => {};
  export let onConfirm: (msg: string, cb: () => void) => void = () => {};

  let stations: Station[] = [];

  $: if (open) {
    stations = M2?.getStations?.() ?? [];
  }

  function getSlotStation(i: number): Station | undefined {
    return stations.find((s: Station) => s.index === i);
  }

  function selectSlot(i: number) {
    if (!station) return;
    const st = getSlotStation(i);
    if (st && st.locked) {
      onConfirm(`This slot is locked. Unlock ${st.label} and replace with ${station.name}?`, () => {
        M2?.setLocked?.(i, false);
        M2?.setStation?.(i, station.url, station.name, station.url_lq, station.url_hq);
        onClose();
      });
    } else if (st) {
      onConfirm(`Replace ${st.label} with ${station.name}?`, () => {
        M2?.setStation?.(i, station.url, station.name, station.url_lq, station.url_hq);
        onClose();
      });
    } else {
      M2?.setStation?.(i, station.url, station.name, station.url_lq, station.url_hq);
      onClose();
    }
  }
</script>

{#if open}
  <div id="slot-picker-overlay" class="open" on:click={onClose} role="dialog" aria-label="Choose a slot for {station?.name ?? 'station'}" tabindex="-1">
    <div class="slot-picker-box" use:trapFocus on:click|stopPropagation>
      <div class="slot-picker-header">
        <span class="slot-picker-title">CHOOSE A SLOT</span>
        <button class="slot-picker-close" on:click={onClose}>[X]</button>
      </div>
      <div id="slot-picker-slots">
        {#each Array.from({ length: 10 }, (_, i) => i + 1) as i}
          {@const st = getSlotStation(i)}
          <button class="sp-slot" class:sp-slot-locked={st?.locked}
            on:click={() => selectSlot(i)} tabindex="0">
            <span class="sp-num">{i}.</span>
            <span class="sp-label" class:empty={!st}>
              {st ? st.label + (st.locked ? ' ★' : '') : '(empty)'}
            </span>
          </button>
        {/each}
      </div>
    </div>
  </div>
{/if}
